// extracted by mini-css-extract-plugin
module.exports = {"coverImageHeight":"500px","highlightColor":"#00c900"};